import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { RBanner } from './RBanner';

interface RPreviewBannerProps {
    message: string;
    onBack: () => void;
    backLabel?: string;
}

export function RPreviewBanner({ message, onBack, backLabel = 'Back to Settings' }: RPreviewBannerProps) {
    return (
        <RBanner variant="warning" badge="Preview Mode" action={<BackLink onClick={onBack}>← {backLabel}</BackLink>}>
            {message}
        </RBanner>
    );
}

const BackLink = styled('button')({
    background: 'none',
    border: 'none',
    fontSize: 13,
    fontWeight: 500,
    color: Colors.darkNavy,
    cursor: 'pointer',
    '&:hover': {
        textDecoration: 'underline',
    },
});
